import camelCase from "lodash/camelCase";
import { Inline } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography/typography";
import { NotificationSetting } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "../notifications_settings_form.module.scss";
import { useNotificationCategoryLabel } from "../use_notification_category_label";

type NotificationSettingTypeCellProps = {
  notificationSetting: NotificationSetting;
};

export const NotificationSettingTypeCell = ({ notificationSetting }: NotificationSettingTypeCellProps) => {
  const { t } = useTranslation("notificationsSettings");

  const getLabel = useNotificationCategoryLabel();
  const label = getLabel(notificationSetting);

  const camelCaseCategory = camelCase(notificationSetting.category);
  const tip = t(`hint.${camelCaseCategory}` as unknown as TemplateStringsArray, {
    defaultValue: ""
  });

  return (
    <Inline className={css.cell} alignItems="center">
      <Typography variant="bodyBold">{label}</Typography>
      {tip && <TooltipIcon content={tip} />}
    </Inline>
  );
};
